/* oxlint-disable typescript/no-explicit-any */
import { TThunkAction } from '../../types/redux';
import { fetchGetEstimationRealtorForm } from '../../../shared/repositories/price-estimator/v1/get-estimation-realtor-form';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EActionTypes } from '../../constants/actionTypes/estimation';
import { TAnswersState } from '../../containers/FormContainer/types/internal';
import { getParameters } from './utils/getParameters';
import { prepareEstimation } from '../../mappers/prepareEstimation/prepareEstimation';
import { IEstimation } from '../../types/estimation/types';
import { ITypedReduxAction } from '../../types/redux/actionType';

const {
  GET_ESTIMATION_REQUEST: REQUEST,
  GET_ESTIMATION_SUCCESS: SUCCESS,
  GET_ESTIMATION_FAILURE: FAILURE,
  GET_ESTIMATION_CLEAR: CLEAR,
} = EActionTypes;

export const requestAction = actionGenerator<typeof REQUEST, void>(REQUEST);
export const successAction = actionGenerator<typeof SUCCESS, IEstimation>(SUCCESS);
export const failureAction = actionGenerator<typeof FAILURE, void>(FAILURE);
export const clearAction = actionGenerator<typeof CLEAR, void>(CLEAR);

export type TGetEstimationActions =
  | ITypedReduxAction<typeof REQUEST, void>
  | ITypedReduxAction<typeof SUCCESS, IEstimation>
  | ITypedReduxAction<typeof FAILURE, void>
  | ITypedReduxAction<typeof CLEAR, void>;

interface IGetEstimationParams {
  answersState: TAnswersState;
}

export const getEstimation =
  ({ answersState }: IGetEstimationParams): TThunkAction<Promise<void>> =>
  (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const parameters = getParameters(answersState);

    if (!parameters) {
      dispatch(failureAction());

      return Promise.resolve();
    }

    dispatch(requestAction());

    return fetchGetEstimationRealtorForm({ httpApi, parameters })
      .then(prepareEstimation)
      .then(estimation => {
        if (estimation) {
          dispatch(successAction(estimation));
        } else {
          dispatch(failureAction());
        }
      })
      .catch(e => {
        logger.error(e);
        dispatch(failureAction());
      });
  };
